// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"2416912b","139":"e457790f","166":"3059f496","180":"17c24616","188":"bc7d9f25","217":"b6f62a6c","250":"d0d83605","262":"73ea9926","303":"1bed3883","395":"4d6b09b7","496":"d210ca98","535":"1d197b4c","857":"13c658c6"}[chunkId] + ".chunk.js";
};